import { WaypointFeatureTier } from '@dashboard/generated/wp/platform';

export function getLabel(tier: WaypointFeatureTier) {
  switch (tier) {
    case WaypointFeatureTier.Free:
      return 'Free';
    case WaypointFeatureTier.Starter:
      return 'Starter';
    case WaypointFeatureTier.Growth:
      return 'Growth';
    case WaypointFeatureTier.Pro:
      return 'Pro';
    case WaypointFeatureTier.Sandbox:
      return 'Sandbox';
    case WaypointFeatureTier.Unlimited:
      return 'Unlimited';
    case WaypointFeatureTier.Sample:
      return 'Sample';
  }
}

export function getPrice(tier: WaypointFeatureTier) {
  switch (tier) {
    case WaypointFeatureTier.Free:
      return '$0';
    case WaypointFeatureTier.Starter:
      return '$20/mo';
    case WaypointFeatureTier.Growth:
      return '$80/mo';
    case WaypointFeatureTier.Pro:
      return '$250/mo';
    case WaypointFeatureTier.Sandbox:
    case WaypointFeatureTier.Unlimited:
    case WaypointFeatureTier.Sample:
      return null;
  }
}

export function getDescription(tier: WaypointFeatureTier) {
  switch (tier) {
    case WaypointFeatureTier.Free:
      return `${getPrice(tier)} - test emails only.`;
    case WaypointFeatureTier.Starter:
      return `${getPrice(tier)} - 10,000 base emails.`;
    case WaypointFeatureTier.Growth:
      return `${getPrice(tier)} - 100,000 base emails.`;
    case WaypointFeatureTier.Pro:
      return `${getPrice(tier)} - 250,000 base emails.`;
    case WaypointFeatureTier.Sample:
    case WaypointFeatureTier.Sandbox:
    case WaypointFeatureTier.Unlimited:
      return null;
  }
}
